<template>
  <v-container fill-height>
    <v-layout
      fill-height
      column
    >
      <!-- Folder pagination start -->
      <v-flex sm12 md12 lg12 class="py-2 my-4 pagination-wrapper mx-1">
        <v-layout row wrap>
          <v-flex sm4 md4 lg4>
            <template v-if="totalFolderPages">
              <v-btn v-if="foldersPage > 1" fab dark small color="primary" class="prev-icon" @click="changeFolder(foldersPage-1)">
                <v-icon dark>chevron_left</v-icon>
              </v-btn>
            </template>
          </v-flex>
          <v-flex sm4 md4 lg4 class="text-xs-center">
            <p v-if="totalFolderPages" :class="totalFolderPages === 1 ? 'mb-0 mt-0 font-weight-bold' : 'font-weight-bold mt-3 mb-0'">{{foldersPage }} / {{ totalFolderPages }} {{ totalFolderPages > 1 ? 'Folders' : 'Folder' }}</p>
            <p v-else :class="totalFolderPages === 1 ? 'mb-0 mt-0 font-weight-bold' : 'font-weight-bold mb-0'">No folder</p>
          </v-flex>
          <v-flex sm4 md4 lg4>
            <template v-if="totalFolderPages">
              <v-btn v-if="foldersPage !== totalFolderPages" fab dark small color="primary" class="next-icon" @click="changeFolder(foldersPage+1 )">
                <v-icon dark>chevron_right</v-icon>
              </v-btn>
            </template>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- Folder pagination ends -->
      <v-flex>
        <!-- path -->
        <v-layout
          row
          wrap
          justify-start
          align-content-center
        >
          <v-flex class="text-center">
            <v-layout
              v-for="(folder, index) in path"
              :key="`folder-${folder.id}`"
              d-inline-flex
              align-content-center
            >
              
              <v-btn
                flat
                @click="getChildFilesAndFoldersOf(folder)"
              >
                {{ folder.parent_id === 0 ? 'Resources' : folder.name }}
              </v-btn>
              <v-icon
                v-if="index + 1 !== path.length"
                :key="`chevron-${folder.id}`"
                class="inner-folder-icon"
              >
                chevron_right
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-divider class="my-2" />

        <!-- new -->
        <v-layout
          row
          align-start
          align-content-start
        >
          <v-flex
            d-inline-flex
            xs12
            sm6
            class="pa-1"
          >

            <v-expansion-panel
              v-model="folderToCreate.expanded"
              expand
            >
              <v-expansion-panel-content
                expand-icon="add"
              >
                <div slot="header">Add a folder</div>
                <v-flex
                  row
                  class="px-4 pb-2"
                >
                  <v-form
                    ref="folderToCreate"
                    v-model="v.folderToCreate.valid"
                    lazy-validation
                  >
                    <v-text-field
                      v-model="folderToCreate.name"
                      :rules="v.folderToCreate.name"
                      label="Folder name"
                      class="d-inline-flex"
                    />
                    <v-btn
                      color="primary"
                      d-inline-flex
                      fab
                      small
                      :disabled="!folderToCreate.name"
                      :loading="folderToCreate.creating"
                      @click="createFolder()"
                    >
                       <v-icon dark>check</v-icon>
                    </v-btn>
                  </v-form>
                </v-flex>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>

          <v-flex
            d-inline-flex
            xs12
            sm6
            class="pa-1"
          >
            <v-expansion-panel
              v-model="fileToCreate.expanded"
              expand
            >
              <v-expansion-panel-content
                expand-icon="add"
              >
                <div slot="header">Add a file</div>
                <v-slide-x-transition mode="out-in">
                  <v-flex
                    row
                    class="px-4 pb-2"
                  >
                    <v-form
                      ref="fileToCreate"
                      v-model="v.fileToCreate.valid"
                    >
                      <v-text-field
                        v-if="fileToCreate.fileName.length"
                        v-model="fileName"
                        label="Selected file"
                        placeholder="JPEG, GIF, PNG, BMP"
                        class="d-inline-flex"
                        readonly
                      />

                      <input style="display:none" type="file" id="uploadFileRef" ref="uploadFileRef" v-on:change="handleFileUpload()"/>

                       <v-btn
                        for="uploadFileRef"
                        color="primary"
                        d-inline-flex
                        outline
                        small
                        :class="fileName ? 'ml-2 open-uploader-btn' : 'ml-0 open-uploader-btn'"
                        @click="openPicker"
                      >
                        {{ fileName ? 'Change Image' : 'Upload Image'}}
                      </v-btn>
                        <!--  -->

                      <v-btn 
                      d-inline-flex
                      class="upload-btn"
                      color="primary" 
                      :dark="fileToCreate.fileName.length > 0"
                      :disabled="fileToCreate.fileName.length === 0"
                      :loading="fileToCreate.creating"
                      fab 
                      small
                      @click="createFile"
                      >
                        <v-icon>check</v-icon>
                      </v-btn>

                      <v-btn 
                        class="upload-cancel-btn"
                        v-if="fileToCreate.fileName"
                        color="darkGrey"
                        dark
                        d-inline-flex
                        small
                        fab
                        :disabled="fileToCreate.creating"
                        @click="cancelCreate"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <input
                        ref="fileInput"
                        type="file"
                        style="display: none"
                        accept=".gif, .jpg, .jpeg, .png, .bmp"
                        @change="addFile"
                      >
                    </v-form>
                  </v-flex>
                </v-slide-x-transition>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>

        <v-divider class="my-2" />

        <!-- folders -->
        <v-layout
          v-if="loaded && folders.length === 0 && files.length === 0"
          row
          wrap
          justify-center
          align-start
        >
          <v-flex
            d-inline-flex
            xs6
            sm3
            class="py-5 text-xs-center"
          >
            <p class="grey--text">This folder is empty</p>
          </v-flex>
        </v-layout>

        <!-- folders -->
        <v-layout
          row
          wrap
          align-start
        >
         

          <v-flex
            v-for="folder in folders"
            :key="folder.id"
            d-inline-flex
            xs6
            sm3
          >
            <v-card
              class="ma-1 pa-2"
            >
              <v-slide-x-transition mode="out-in">

                <v-layout
                  v-if="folderToEdit.id === folder.id"
                  column
                  class="pa-2"
        
                >
                  <v-form
                    ref="folderToEdit"
                    v-model="v.folderToEdit.valid"
                  >
                    <v-text-field
                      v-model="folder.name"
                      :rules="v.folderToEdit.name"
                      class="d-inline-flex"
                    />
                    <v-btn
                      flat
                      :loading="folderToEdit.saving"
                      @click="saveFolder(folder)"
                    >Save</v-btn>
                    <v-btn
                      flat
                      :disabled="folderToEdit.saving"
                      @click="resetFolderToEdit()"
                    >Cancel</v-btn>
                  </v-form>
                </v-layout>

                <v-layout
                  v-else
                  class="pa-2 black--text"
                  column
                  @click="getChildFilesAndFoldersOf(folder)"
                >
                  <v-layout
                    row
                    justify-start
                    align-center
                  >
                    <div class="folder pointer">
                      <v-icon class="mr-1">folder</v-icon>
                    {{ folder.name }}
                    </div>
                  </v-layout>
                  <v-layout
                    row
                    justify-end
                  >
                    <v-btn
                      flat
                      icon
                      @click.stop="editFolder(folder)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      icon
                      @click.stop="deleteFolder(folder)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>

                  </v-layout>
                  <v-slide-y-transition>
                    <v-layout
                      v-if="folderToDelete.id === folder.id"
                      column
                    >
                      <v-btn
                        flat
                        :loading="folderToDelete.deleting"
                        @click.stop="removeFolder"
                      >Delete</v-btn>
                      <v-btn
                        flat
                        :disabled="folderToDelete.deleting"
                        @click.stop="resetFolderToDelete"
                      >Cancel</v-btn>
                    </v-layout>
                  </v-slide-y-transition>
                </v-layout>
              </v-slide-x-transition>
            </v-card>

          </v-flex>
        </v-layout>
        <!-- images -->
        <v-layout
          row
          wrap
        >
           <!-- Image pagination start -->
          <v-flex sm12 md12 lg12 class="py-2 my-4 pagination-wrapper mx-1">
            <v-layout row wrap>
              <v-flex sm4 md4 lg4>
                <v-btn v-if="filesPage > 1" fab dark small color="primary" class="prev-icon" @click="changePage(filesPage-1)">
                  <v-icon dark>chevron_left</v-icon>
                </v-btn>
              </v-flex>
              <v-flex sm4 md4 lg4 class="text-xs-center">
                <p :class="totalPages === 1 ? 'mb-0 mt-0 font-weight-bold' : 'font-weight-bold mt-3 mb-0'">{{filesPage }} / {{ totalPages }} {{ totalPages > 1 ? 'Pages' : 'Page' }}</p>
              </v-flex>
              <v-flex sm4 md4 lg4>
                <v-btn v-if="filesPage !== totalPages" fab dark small color="primary" class="next-icon" @click="changePage(filesPage+1 )">
                  <v-icon dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- Image pagination ends -->
         
          <v-flex
            d-inline-flex
            xs12
            sm12
            class="text-center"
            v-if="images.length < 1"
          >
            <p class="grey--text">No files</p>
          </v-flex>

          <v-flex
            v-for="image in images"
            :key="image.id"
            d-inline-flex
            xs6
            sm3
          >
            <v-card
              class="ma-1"
            >
              <v-layout
                column
                class="relative overflow-hidden"
              >
                <image-container
                  :imgobj="image"
                  :src="image.url"
                />
                <div class="actions-wrapper">
                  <v-layout
                    v-if="fileToDelete.id !== image.id"
                    justify-end
                  >
                    <v-btn
                      icon
                      @click="deleteFile(image)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-layout>
                  <v-layout
                    :class="fileToDelete.id === image.id ? 'image-actions show': 'image-actions'"
                    row
                    wrap
                    transition="slide-x-reverse-transition"
                  >
                    <v-flex md6 sm12 class="pl-2 pr-1">
                       <v-btn
                        color="primary"
                        :loading="fileToDelete.deleting"
                        @click="removeFile"
                        block
                      >Delete</v-btn>
                    </v-flex>
                     <v-flex md6 sm12 class="pr-2 pl-1">
                      <v-btn
                        color="primary"
                        block
                        :disabled="fileToDelete.deleting"
                        @click="resetFileToDelete()"
                      >Cancel</v-btn>
                    </v-flex>
              
                  </v-layout>
                </div>
                <!-- <v-btn
                  color="primary"
                  @click="selectImage(image)"
                >Select</v-btn> -->

              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import ResourcesFunctions from './controllers/Resources'
import { resourcesBusinessId } from './controllers/global'
import placeholder from './utils/loadingImage.js'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Resources',
  data: () => ({
    resourcesBusinessId: null,
    loading: {
      rootFolder: false,
      folders: false,
      files: false
    },

    rootFolder: {},
    path: [],

    folders: [],
    foldersPage: 1,
    totalFolderPages: 1,
    folderToCreate: {
      expanded: [false],
      creating: false,
      is_shared: 1
    },
    folderToEdit: { saving: false },
    folderToDelete: { deleting: false },
    uploadFileRef: '',
    files: [],
    filesPage: 1,
    totalPages: 1,
    fileToCreate: {
      expanded: [false],
      fileName: '',
      file: null,
      formData: null
    },
    fileToEdit: { saving: false },
    fileToDelete: { deleting: false },

    v: {
      folderToCreate: {
        valid: false,
        name: [
          v => !!v || 'Name missing'
        ]
      },
      folderToEdit: {
        valid: false,
        name: [
          v => !!v || 'Name missing'
        ]
      },
      fileToCreate: {
        valid: false
      }
    }
  }),
  computed: {
    currentFolder () {
      const pathLength = this.path.length
      if (pathLength) {
        return this.path[pathLength - 1]
      } else {
        return null
      }
    },
    images () {
      return this.files.filter(file => {
        const imageExtensions = ['gif', 'jpg', 'jpeg', 'png', 'bmp']
        return imageExtensions.includes(file.extension)
      })
    },
    fileName: {
      set: function () {},
      get () {
        return this.fileToCreate.fileName
      }
    },
    loaded () {
      const loaders = Object.keys(this.loading)
      return !loaders.some(key => this.loading[key])
    },
  },
  created () {
    this.placeholder = placeholder
    this.resourcesBusinessId = this.$store.getters.getLoggedInUserSelectedBusinessId;
    this.getRootFolder()
  },
  beforeRouteLeave (to, from, next) {
    this.setRedirectTo({})
    next()
  },
  mounted() {
    this.attachmentActive(false);
    this.attachmentData({
      obj: {},
      action: '',
      target: '',
    });
  },
  methods: {

    /**
     * Chnage page 
     */
    changePage(pageNo){
      this.filesPage = pageNo;
      this.getChildFilesOf(this.currentFolder.id)
    },

    /**
     * Chnage folder
     */
    changeFolder(folderNo){
      this.foldersPage = folderNo;
      this.getChildFoldersOf(this.currentFolder.id)
    },
     
     handleFileUpload() {
      this.uploadFileRef = this.$refs.uploadFileRef.files[0];
      if(this.uploadFileRef.name) {
         this.fileToCreate.fileName = this.uploadFileRef.name;
      } else {
        this.fileToCreate.fileName = '';
      }
    },

    logger (x) {
      console.log(x)
    },

    updatePath (nextFolder) {
      const pathLength = this.path.length
      const currentFolder = this.path[pathLength - 1]
      const indexInPath = this.path.findIndex(folder => folder.id === nextFolder.id)

      if (currentFolder.id === nextFolder.parent_id) {
        // push onto folder stack
        this.path.push(nextFolder)
      } else if (indexInPath !== -1) {
        // pop off folder stack
        this.path.splice(indexInPath + 1)
      }
      this.resetFolderToEdit()
      this.resetFolderToDelete()
      this.resetFileToDelete()
    },

    createFolder () {
      if (this.v.folderToCreate.valid) {
        this.folderToCreate.creating = true

        ResourcesFunctions.createFolder({
          businessId: this.resourcesBusinessId,
          folder: this.folderToCreate,
          parentFolderId: this.currentFolder.id
        })
          .then(response => {
            this.getChildFoldersOf(this.currentFolder.id)
            this.snackbar({
              text: response.pending_approval ? 'Sent for approval' : 'Saved',
              timeout: 5000,
              open: true
            })
            this.resetFolderToCreate()
          })
          .catch(reason => {
            let text = 'Creating folder failed'
            if (reason.responseJSON && reason.responseJSON.declaration === 'already_exists') {
              text = 'Folder already exists'
            }
            this.snackbar({
              text,
              open: true
            })
          })
          .finally(() => {
            this.folderToCreate.creating = false
          })
      }
    },
    resetFolderToCreate () {
      const expanded = [this.folderToCreate.expanded[0]]
      this.folderToCreate = {
        expanded,
        creating: false,
        is_shared: 1
      }
      this.$refs.folderToCreate.reset()
    },
    openPicker () {
      // this.$refs.fileInput.click()
      this.$refs.uploadFileRef.click()
      
    },
    addFile (event) {
      const files = event.target.files
      if (!files.length) {
        this.cancelCreate()
      } else {
        const formData = new FormData()
        Array.from(Array(files.length).keys()).map(x => {
          formData.append('file', files[x], files[x].name)
        })
        this.fileToCreate.formData = formData
        this.fileToCreate.fileName = files[0].name
        if (this.fileToCreate.fileName.lastIndexOf('.') <= 0) {
          return
        }
        this.fileToCreate.file = files[0]
      }
    },
    cancelCreate () {
      this.$refs.fileInput.blur()
      this.fileToCreate.file = null
      this.fileToCreate.fileName = ''
      this.fileToCreate.formData = null
      this.$refs.fileToCreate.reset()
    },
    createFile () {
      
      if (this.fileToCreate.fileName !== null) {
        let fileExt = this.fileToCreate.fileName.split('.').pop();
        if(fileExt == 'jpeg' || fileExt == 'png' || fileExt == 'jpg' || fileExt == 'gif'){
          const contentType = `image/${fileExt}`;
          this.fileToCreate.creating = true;
          this.spinner(true);
          ResourcesFunctions.createFile({
            businessId: this.resourcesBusinessId,
            file: this.fileToCreate.formData,
            folderId: this.currentFolder.id,
            contentType: contentType,
            uploadFileRef: this.uploadFileRef,
          })
            .then(response => {
              this.spinner(false);
              this.getChildFilesOf(this.currentFolder.id)
              this.snackbar({
                text: response.pending_approval ? 'Sent for approval' : 'Saved',
                timeout: 5000,
                open: true
              })
              this.resetFileToCreate()
            })
            .catch(reason => {
              this.spinner(false);
              this.snackbar({
                text: 'Creating file failed',
                open: true
              })
            })
            .finally(() => {
              this.fileToCreate.creating = false
            })
        } else {
          this.snackbar({
            open: true,
            text: 'Invalid file. Supports JPEG / JPG / PNG / GIF.'
          });
        }
      }
    },
    resetFileToCreate () {
      const expanded = [this.fileToCreate.expanded[0]]
      this.fileToCreate = {
        expanded,
        fileName: '',
        file: null,
        formData: null
      }
    },

    editFolder (folder) {
      if (this.folderToDelete.id === folder.id) {
        this.cancelDeleteFolder(folder)
      }
      this.folderToEdit = folder
    },
    resetFolderToEdit () {
      this.folderToEdit = { saving: false }
    },
    saveFolder (folder) {
      if (this.v.folderToEdit.valid) {
        this.folderToEdit.saving = true

        ResourcesFunctions.saveFolder({
          businessId: this.resourcesBusinessId,
          folderId: this.folderToEdit.id,
          folderName: this.folderToEdit.name
        })
          .then(response => {
            this.resetFolderToEdit()
            this.snackbar({
              text: response.pending_approval ? 'Sent for approval' : 'Saved',
              timeout: 5000,
              open: true
            })
          })
          .catch(reason => {
            let text = 'Saving folder failed'
            if (reason.responseJSON && reason.responseJSON.declaration === 'already_exists') {
              text = 'Saving folder failed: folder with this name already exists'
            }
            this.snackbar({
              text,
              open: true,
              timeout: 3000
            })
          })
          .finally(() => {
            this.folderToEdit.saving = false
          })
      }
    },
    deleteFolder (folder) {
      if (this.folderToEdit.id === folder.id) {
        this.cancelEditFolder()
      }
      this.folderToDelete = folder
    },
    resetFolderToDelete () {
      this.folderToDelete = { deleting: false }
    },
    removeFolder (folder) {
      this.folderToDelete.deleting = true
      return new Promise((resolve, reject) => {
        ResourcesFunctions.deleteFolder({
          businessId: this.resourcesBusinessId,
          folderId: this.folderToDelete.id
        })
          .then(response => {
            const index = this.folders.findIndex(stale => stale.id === this.folderToDelete.id)
            this.folders.splice(index, 1)
            this.resetFolderToDelete()
            this.snackbar({
              text: 'Deleted',
              open: true,
              timeout: 3000
            })
          })
          .catch(reason => {
            this.snackbar({
              text: 'Deleting failed',
              open: true
            })
          })
          .finally(() => {
            this.folderToDelete.deleting = false
          })
      })
    },

    editImage (image) {
      if (this.fileToDelete.id === image.id) {
        this.cancelDeleteImage(image)
      }
      this.fileToEdit = image
    },
    cancelEditImage () {
      this.fileToEdit = {}
    },
    saveImage () {
      return new Promise((resolve, reject) => {
        this.saving = true
        ResourcesFunctions.updateFolder()
          .then(response => {
            // folder ? updateState : refetch
            // .then(() => this.clearEditFolder())
          })
          .catch(reason => {
            this.snackbar({
              text: 'Saving failed',
              open: true
            })
          })
          .finally(() => {
            this.saving = false
          })
      })
    },

    deleteFile (image) {
      if (this.fileToEdit.id === image.id) {
        this.resetFileToDelete()
      }
      this.fileToDelete = image
    },
    resetFileToDelete () {
      this.fileToDelete = { deleting: false }
    },
    removeFile () {
      return new Promise((resolve, reject) => {
        this.fileToDelete.deleting = true
        ResourcesFunctions.deleteFile({
          businessId: this.resourcesBusinessId,
          fileId: this.fileToDelete.id
        })
          .then(response => {
            const index = this.files.findIndex(stale => stale.id === this.fileToDelete.id)
            this.files.splice(index, 1)
            this.resetFileToDelete()
            this.snackbar({
              text: 'Deleted',
              open: true,
              timeout: 3000
            })
          })
          .catch(reason => {
            console.log({ reason })
            this.snackbar({
              text: 'Deleting failed',
              open: true
            })
          })
          .finally(() => {
            this.fileToDelete.deleting = false
          })
      })
    },

    getRootFolder () {
      this.loading.rootFolder = true
      return new Promise((resolve, reject) => {
        ResourcesFunctions
          .getFolders({
            parentFolderId: 0,
            businessId: this.resourcesBusinessId,
            pageNumber: this.filesPage
          })
          .then(response => {
     
            const rootFolder = response.payload.folders.find(folder => folder.parent_id === 0)
            this.getChildFoldersOf(rootFolder.id)
            this.getChildFilesOf(rootFolder.id)
            this.path.push(rootFolder)
            resolve(response)
          })
          .catch(reason => {
            reject(reason)
            this.snackbar({
              open: true,
              text: 'We couldn\'t fetch your resources'
            })
          })
          .finally(() => {
            this.loading.rootFolder = false
          })
      })
    },
    getChildFoldersOf (parentFolderId) {
      this.loading.folders = true
      return new Promise((resolve, reject) => {
        ResourcesFunctions
          .getFolders({
            parentFolderId,
            businessId: this.resourcesBusinessId,
            pageNumber: this.foldersPage
          })
          .then(response => {
           this.totalFolderPages = response.payload.number_of_pages;
            this.folders = response.payload.folders.map(folder => {
              return {
                ...folder,
                saving: false,
                deleting: false
              }
            })
            resolve(response)
          })
          .catch(reason => {
            this.totalFolderPages = 0;
            reject(reason)
          })
          .finally(() => {
            this.loading.folders = false
          })
      })
    },
    getChildFilesAndFoldersOf (folder) {
      // if this is the current folder, don't do anything
      if (this.path.length && folder.id === this.path[this.path.length - 1].id) return

      Promise.all([
        this.getChildFoldersOf(folder.id),
        this.getChildFilesOf(folder.id)
      ])
        .then(response => {
          this.updatePath(folder)
        })
        .catch(reasons => {
          this.snackbar({
            open: true,
            text: 'We couldn\'t fetch contents of this folder'
          })
        }

        )
    },
    getChildFilesOf (parentFolderId) {
      this.spinner(true);
      this.loading.files = true
      return new Promise((resolve, reject) => {
        ResourcesFunctions
          .getFiles({
            parentFolderId,
            businessId: this.resourcesBusinessId,
            pageNumber: this.filesPage
          })
          .then(response => {
            this.spinner(false);
            this.totalPages = response.payload.number_of_pages;
            this.files = response.payload.files
            resolve(response)
          })
          .catch(reason => {
            this.spinner(false);
            reject(reason)
          })
          .finally(() => {
            this.spinner(false);
            this.loading.files = false
          })
      })
    },

    selectImage (image) {
      // Insert image data in store and hide popup
      this.attachmentData({
        obj: image,
      });
    },
    ...mapActions({
       spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
      attachmentData: 'attachment/setData',
      attachmentActive: 'attachment/setActive',
    })
  }
}
</script>
<style>
.image-actions {
    position: absolute;
    left: -100%;
    bottom: 0;
    width: 100%;
    transition: all 0.4s ease-in-out;
    -webkit-transition: all 0.4s ease-in-out;
}
.image-actions.show {
    left: 0px;
    transition: all 0.4s ease-in-out;
    -webkit-transition: all 0.4s ease-in-out;
}
.actions-wrapper {
    position: relative;
    bottom: 4px;
    left: 0;
    right: 0;
    width: 100%;
    min-height: 54px;
}
.inner-folder-icon {
  position: relative;
  top: 15px;
}
.info-color-content .theme--light.upload-btn.v-icon{
  color: #fff;
}
.next-icon {
    float: right;
}
.prev-icon {
    float: left;
}
.pagination-wrapper {
    background: #ecebeb;
}
.inner-folder-icon {
    position: relative;
    top: 0;
}
</style>